import React from 'react'
import styled from 'styled-components'

const StyledMyProgress = styled.div`
  height: 4px;
  border-radius: 180px;
  background: rgba(255, 255, 255, 0.2);
  .progress-outer {
    position: relative;
    height: 4px;
  }
  .progress-inner {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-top-left-radius: 180px;
    border-bottom-left-radius: 180px;
    background: #ffd166;
  }
  .progress-text {
    position: absolute;
    top: -8px;
    background: #ffd166;
    border-radius: 180px;
    color: ${props => props.theme.dark1};
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    padding: 0 6px;
    text-align: center;
  }
  &.progress-primary {
    background: #e6e8ec;
    .progress-inner,
    .progress-text {
      background: ${props => props.theme.primaryColor};
      color: #ffffff;
    }
  }
`

export const MyProgress: React.FC<{
  percent: number
  format?: (prercent: number) => string
  showInfo?: boolean
  textWidth?: number
  className?: string
  max?: number
}> = ({
  percent: _percent,
  format,
  showInfo = true,
  textWidth = 100,
  className,
  max = 100,
}) => {
  const percent = _percent < 0 ? 0 : _percent > max ? max : _percent

  return (
    <StyledMyProgress className={className}>
      <div
        className="progress-outer"
        style={{
          width: `calc(100% - ${textWidth}px)`,
        }}
      >
        <div
          className="progress-inner"
          style={{
            width: `${percent > 100 ? 100 : percent}%`,
          }}
        ></div>
        {showInfo && (
          <div
            className="progress-text"
            style={{
              width: `${textWidth}px`,
              left: `${percent > 100 ? 100 : percent}%`,
            }}
          >
            {format?.(percent) || `${percent}%`}
          </div>
        )}
      </div>
    </StyledMyProgress>
  )
}
